<template>
    <div class="flex-col justify-start relative page">
        <div class="flex-col justify-start items-center">
            <img class="image_1" src="@/assets/imglv1/obituary/bgSp.jpg" />
            <!-- <img class="image_2" src="@/assets/imglv1/obituary/bg.gif" /> -->
        </div>
        <div class="content">
            <div class="content_t">
                <div class="avaterm">
                    <img class="avaterImg" :src="details.image" alt="">
                </div>
                <div class="name">
                    <span>{{ details.name }}</span>
                    <span style="padding-left: .4rem;">{{ details.appellation }}</span>
                </div>

                <div class="wzcont" v-html="details.obituary">

                </div>

            </div>
        </div>

        <div class="contentB">
            <div class="danmu">
                <!--插件地址  https://www.npmjs.com/package/vue-danmaku -->
                <vue-danmaku v-if="danmushow" v-model="list" useSlot style="height:100%; width:100%;" randomChannel
                    :performance="true" :speeds="20" :autoplay="false" ref="danmaku" :debounce="800" :channels="2"
                    @play-end="playend">
                    <template slot="dm" slot-scope="{ index, danmu }">
                        <div class="list" v-if="danmu.type == 1 || danmu.type == 2 || danmu.type == 3">
                            <div class="wz wzbg5" v-show="danmu.type == 1">
                                <div class="h_center">
                                    <div class="h_center clol6">
                                        <div>{{ danmu.nickname }}</div>
                                        <div>送了一朵{{ danmu.oblation_name }}</div>
                                    </div>
                                    <img :src="danmu.image" alt="">
                                </div>
                            </div>
                            <div class="wz wzbg5" v-show="danmu.type == 2">
                                <div class="h_center">
                                    <div class="h_center clol6">
                                        <div>{{ danmu.nickname }}</div>
                                        <div>上了一炷{{ danmu.oblation_name }}</div>
                                    </div>
                                    <img :src="danmu.image" alt="">
                                </div>
                            </div>
                            <div class="wz wzbg5" v-show="danmu.type == 3">
                                <div class="h_center">
                                    <div class="clol6">{{ danmu.nickname }}说:{{ danmu.content }}</div>
                                    <div style="height: .5rem"></div>
                                </div>
                            </div>
                        </div>

                    </template>
                </vue-danmaku>
            </div>

            <!-- <div class="ewm-bt" :class="{ ewmCenter: !hasTools }">
                <img :src="ewm" alt="" class="ewm" />
                <div>
                    <div class="ewm-icon">扫码祭奠</div>
                </div>
            </div> -->
        </div>

        <img class="flower1" src="@/assets/imglv1/obituary/flower1.gif" alt="">

        <KongmingLanternSp></KongmingLanternSp>
    </div>
</template>
<script>
import QRCode from "qrcode";
import vueDanmaku from 'vue-danmaku';
import { getList, obituaryGet, ttsToken } from "@/api/go";
import KongmingLanternSp from '@/components/vfx/KongmingLanternSp';
import { connectWebsocket, closeWebsocket, sendMsg } from "@/config/websocket.js";

export default {
    components: {
        vueDanmaku,
        KongmingLanternSp
    },

    beforeRouteEnter(to, from, next) {
        let s = to.query.s;
        if (s) {
            if (s == 1) {
                next({
                    name: "index",
                    query: to.query
                });
            } else if (s == 2) {
                next({
                    name: "farewell",
                    query: to.query
                });
            } else if (s == 3) {
                next();
            }
        } else {
            next();
        }
    },
    data() {
        return {
            id: "",
            ewm: "",
            list: [],
            hasTools: !this.$route.query.s,
            page: 1,
            motif: 1,
            details: '',
            timer: '',
            timer2: '',
            danmushow: true,
            request: require('request'),
            voiceEnabled: true, // 语音播报开关
            audioContext: null,
            lastSpeechTime: 0, // 上次语音播报时间
            speechQueue: [], // 语音播报队列
            isSpeaking: false, // 是否正在播报
            comment: false,
            intervalId: null,
            showaudio: false,
            opensocket:false
        };
    },
    mounted() {
        this.motif = localStorage.getItem('motif') || 1

        // // 检查浏览器是否支持语音合成
        // if (!this.speechSynthesis) {
        //   console.warn('该浏览器不支持语音合成API')
        //   this.voiceEnabled = false
        // }
        // 初始化语音合成

        this.initSpeech()
        this.startInterval()

    },
    computed: {

    },
    watch: {

    },
    methods: {

        startInterval() {
            this.intervalId = setInterval(() => {
                // console.log("// 处理语音队列")
                this.processSpeechQueue()
            }, 1000);
        },
        stopInterval() {
            clearInterval(this.intervalId);
            this.intervalId = null;
        },
        // 处理语音队列
        processSpeechQueue() {
            if (this.isSpeaking) {
                return;
            }
            if (this.speechQueue.length === 0) {
                this.isSpeaking = false
                return
            }

            ttsToken({}).then(res => {
                console.log(res, '12131')
                this.isSpeaking = true
                // 从队列中取出第一条
                const text = this.speechQueue.shift()
                let url = this.processGETRequest(text, res)

                this.playAudio(url)
            }).catch(err => {
                console.log(err)
            });

        },
        // 语音播报方法
        speak(text) {
            if (!this.voiceEnabled || !text) return
            // 添加到语音队列
            this.speechQueue.push(text)
        },

        async playAudio(url) {
            let that = this
            console.log("播放语音")
            try {
                const audio = new Audio(url);
                audio.play()
                // 等待音频播放结束
                await new Promise(resolve => {
                    audio.addEventListener('ended', resolve);
                })

                setTimeout(() => {
                    that.isSpeaking = false
                }, 200);

                return audio;
            } catch (error) {
                console.error('获取TTS音频失败:', error);
                throw error;
            }

        },
        // 初始化语音设置
        initSpeech() {

            try {
                this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            } catch (e) {
                this.error = '您的浏览器不支持Web Audio API';
                console.error(e);
            }
        },
        playend() {
            // console.log('弹幕到底了')
            let that = this
            this.danmushow = false
            // console.log(this.list)
            this.timer3 = setTimeout(() => {
                that.danmushow = true
                this.page = 1
                this.list = []
                this.getLiuyan()
                // that.$nextTick(() => {
                //   that.$refs.danmaku.play()
                // });
            }, 1000 * 3);
        },
        // 二维码生成
        getEWM(comment) {

            let url = ''
            if (comment) {
                url = location.origin + `/mobilelt?id=${this.id}&ty=1&SweetShow=${this.details.belief}`
            } else {
                url = location.origin + `/mobilelt?id=${this.id}&SweetShow=${this.details.belief}`
            }

            console.log(url)
            // SweetShow 区分是否展示上香  有些情况不展示上香



            QRCode.toDataURL(url)
                .then(url => {
                    this.ewm = url;
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getLiuyan() {
            getList({
                userId: Number(this.id),
                page: this.page,
                limit: 20,
                device: 'pc'
            }).then(res => {
                if (this.page == 1 && res.data.length == 0) {
                    console.log('没弹幕')
                    setTimeout(() => {
                        this.getLiuyan()
                    }, 1000 * 3);
                    return
                }


                let array2 = res.data
                this.list = this.list.concat(array2)


                // console.log(this.list)
                if (this.page < res.totalPage) {
                    this.page++
                    this.getLiuyan()
                } else if (res.total > 0) {
                    if (!this.opensocket) {
                        this.initWebSocket(res.lastId);
                    }
                    this.$nextTick(() => {
                        this.$refs.danmaku.play()
                    });
                } else {
                    console.log('没有更多了')
                    // setTimeout(() => {
                    //   this.getLiuyan()
                    // }, 1000 * 3);
                }

            }).catch(err => {
                console.log(err, '链接错误')
                // 确保断网重连
                setTimeout(() => {
                    this.getLiuyan()
                }, 1000 * 3);
            });
        },
        getURL(url) {
            if (!url) {
                return url;
            }
            if (url.includes("http")) {
                return url;
            } else {
                return `https://immortal-space.oss-cn-hangzhou.aliyuncs.com` + url;
            }
        },
        back() {
            this.$router.replace({
                name: "list",
                query: {
                    id: this.id
                }
            });
        },
        // 获取信息
        detileData(ty) {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            obituaryGet({
                userId: Number(this.id)
            }).then(res => {
                console.log(res, 'res')
                this.details = res
                this.comment = res.comment
                if (ty) {
                    this.getEWM(res.comment);
                }
                this.timer = setTimeout(() => {
                    this.detileData()
                }, 1000 * 60 * 10);
            }).catch(err => {

            });
        },
        processGETRequest(text, token) {
            var appkey = 'PjpYORQfUsoilGvX';
            var textUrlEncode = encodeURIComponent(text)
                .replace(/[!'()*]/g, function (c) {
                    return '%' + c.charCodeAt(0).toString(16);
                });
            console.log(textUrlEncode);
            var audioSaveFile = 'syAudio.wav';
            var format = 'wav';
            var sampleRate = 16000;

            var url = 'https://nls-gateway-cn-shanghai.aliyuncs.com/stream/v1/tts';
            /**
             * 设置URL请求参数。
             */
            url = url + '?appkey=' + appkey;
            url = url + '&token=' + token;
            url = url + '&text=' + text;
            url = url + '&format=' + format;
            url = url + '&sample_rate=' + sampleRate;
            // voice 发音人，可选，默认是xiaoyun。
            url = url + "&voice=" + "zhiyue";
            // volume 音量，范围是0~100，可选，默认50。
            // url = url + "&volume=" + 50;
            // speech_rate 语速，范围是-500~500，可选，默认是0。
            // url = url + "&speech_rate=" + 0;
            // pitch_rate 语调，范围是-500~500，可选，默认是0。
            // url = url + "&pitch_rate=" + 0;
            console.log(url);
            // /**
            //  * 设置HTTPS GET请求。
            //  * encoding必须设置为null，HTTPS响应的Body为二进制Buffer类型。
            //  */
            // var options = {
            //   url: url,
            //   method: 'GET',
            //   encoding: null
            // };
            // this.request(options, function (error, response, body) {
            //   /**
            //    * 处理服务端的响应。
            //    */
            //   if (error != null) {
            //     console.log(error);
            //   }
            //   else {
            //     var contentType = response.headers['content-type'];
            //     if (contentType === undefined || contentType != 'audio/mpeg') {
            //       console.log(body.toString());
            //       console.log('The GET request failed!');
            //     }
            //     else {
            //       fs.writeFileSync(audioSaveFile, body);
            //       console.log('The GET request is succeed!');
            //     }
            //   }
            // });

            return url;
        },

        initWebSocket(mid) {
            // mid 最后一条弹幕id 长连接用
            let data = {
                userid: Number(this.id),//逝者ID
                mid: mid ? mid : 0,
            }
            connectWebsocket("wss://api.szskapp.com/spaceDialogue/ws2", data, (ret) => {
                if (ret) {
                    this.opensocket=true
                    console.log('收到数据', ret)
                    let res = JSON.parse(ret)
                    if (res.data) {
                        console.log(res.data)
                        let array1 = this.list
                        let array2 = res.data
                        // 提取 array2 中 id 不在 array1 中的对象
                        // let uniqueInArray2 = array2.filter(item2 =>
                        //   !array1.some(item1 => item1.id === item2.id)
                        // );
                        // if (uniqueInArray2.length > 0) {
                        //   this.list = this.list.concat(uniqueInArray2)
                        // }
                        if (this.comment) {
                            res.data.forEach(item => {
                                let content = item.nickname
                                console.log("0000000000")
                                if (item.type == 1) {
                                    console.log("aa")
                                    content = content + "送了一朵" + item.oblation_name
                                } else if (item.type == 2) {
                                    console.log("bb")
                                    content = content + "上了一炷" + item.oblation_name
                                } else if (item.type == 3) {
                                    console.log("c")
                                    content = content + "说:" + item.content
                                }
                                console.log(content)

                                this.speak(content)
                                // this.processGETRequest(content)

                            })
                        }
                    }

                }
            },
                (err) => {
                    this.opensocket=false
                    // console.log("Socket断开");
                })
        },
    },
    created() {
        // location.reload(true);
        this.id = this.$route.query.id;
        this.getLiuyan();
        this.detileData(1)
        // console.log('加载')
        // 每4小时刷新页面 防止内存超出
        this.timer2 = setTimeout(() => {
            // console.log('刷新')
            this.$router.replace({
                name: "obituary",
                query: {
                    id: this.id,
                    time: Date.parse(new Date())
                }
            });
            window.location.reload()
        }, 1000 * 60 * 60 * 3);
    },
    beforeDestroy() {
        // console.log('销毁')
        clearInterval(window.timer);
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        if (this.timer2) {
            clearInterval(this.timer2);
            this.timer2 = null;
        }
        if (this.timer3) {
            clearInterval(this.timer3);
            this.timer3 = null;
        }

        //停止定时器
        this.stopInterval()

        // 清除语音队列
        this.speechQueue = []
        if (this.speechSynthesis) {
            this.speechSynthesis.cancel()
        }

        closeWebsocket()
    }
};
</script>
<style lang="less" scoped>
.page {
    width: 100%;
    height: 100%;
    position: relative;

    .image_1 {
        width: 100vw;
        height: 100vh;
    }

    .image_2 {
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 20;
    }
}


.content {
    // justify-content: space-between;
    position: fixed;
    left: 0.6rem;
    right: 0.6rem;
    top: .8rem;
    bottom: 0;
    // background: red;
    z-index: 50 !important;


    .content_t {
        .avaterm {
            text-align: center;
            margin: 0 auto;

            .avaterImg {
                width: 3rem;
                height: 4.2rem;
                border-radius: 0.05rem;
            }
        }

        .name {
            text-align: center;
            font-size: 0.5rem;
            color: #000000;
            padding-top: 0.4rem;
        }

        .wzcont {
            padding-top: 0.45rem;
            font-size: 0.4rem !important;
            color: #000000;
        }
    }




}

.contentB {
    position: fixed;
    left: 0rem;
    right: 0.6rem;
    bottom: .5rem;
    // background: red;
    z-index: 100 !important;

    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3rem;

    .danmu {
        width: 80%;
        height: 2rem;

        .list {
            margin-bottom: 0.3rem;
            font-size: 0.3rem;
            color: #000000;

            .wz {
                padding: 0.1rem 0.2rem;
                border-radius: .5rem;
                display: inline-block;

                img {
                    height: 0.5rem;
                    margin-left: 0.1rem;
                }
            }

            .wzbg5 {
                background: rgba(0, 0, 0, 0.5);
            }

            .wzbg6 {
                background: #FF9672;
            }
        }
    }

    .ewm {
        width: 2.17rem;
        height: 100%;
        border-radius: 0.08rem;
    }

    .ewm-icon {
        margin: 0 auto;
        // width: 230px;
        // margin-top: 20px;
        color: #000;
        text-align: center;
        font-size: 0.5rem;
        font-weight: bold;
        font-family: KaiTi;
    }

}


.flower1 {
    position: fixed;
    left: 0.6rem;
    bottom: 1rem;
    width: 3rem;
    z-index: 10;
}




.clol5 {
    color: #fff;
}

.clol6 {
    color: #fff;
}

.h_center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.contentewm {}
</style>